/**
 * ScenarioIcon — Renders scenario SVG icons with custom color and stroke.
 * Uses inline SVG for full styling control.
 *
 * Usage:
 *   <ScenarioIcon scenario="teknologia" color="#008549" size={32} />
 */
import React, { useState, useEffect } from 'react';

const SCENARIO_SVGS = {
  ilmasto: '/assets/icons/climate.svg',
  demokratia: '/assets/icons/democracy.svg',
  väestö: '/assets/icons/population.svg',
  vaesto: '/assets/icons/population.svg',
  teknologia: '/assets/icons/technology.svg',
};

const svgCache = {};

export default function ScenarioIcon({ scenario, color = '#666', size = 32, strokeWidth = 2 }) {
  const [svgContent, setSvgContent] = useState(svgCache[scenario] || null);

  const src = SCENARIO_SVGS[scenario?.toLowerCase()];

  useEffect(() => {
    if (!src) return;
    if (svgCache[scenario]) { setSvgContent(svgCache[scenario]); return; }
    fetch(src)
      .then(r => r.text())
      .then(text => { svgCache[scenario] = text; setSvgContent(text); })
      .catch(() => {});
  }, [scenario, src]);

  if (!svgContent) return <div style={{ width: size, height: size }} />;

  const colored = svgContent
    .replace(/stroke="[^"]*"/g, `stroke="${color}" stroke-width="${strokeWidth}"`)
    .replace(/width="\d+"/, `width="${size}"`)
    .replace(/height="\d+"/, `height="${size}"`);

  return <div style={{ width: size, height: size, flexShrink: 0 }} dangerouslySetInnerHTML={{ __html: colored }} />;
}

export function getScenarioKey(title) {
  const lower = title?.toLowerCase() || '';
  for (const key of Object.keys(SCENARIO_SVGS)) {
    if (lower.includes(key)) return key;
  }
  return null;
}
